import { useState, useCallback } from "react";
import useAccountForm from "../../MyCompany/components/hooks/useAccountForm";
import createAccountSubmitHandler from "../../MyCompany/components/utils/accountSubmitHandler";
import { useCreateMerchantInstitutionMobileMoneyAccount } from "../../../hooks/queries/useMerchantQueries";

export const useMobileMoneyModal = () => {
  const [selectedMerchantInstitution, setSelectedMerchantInstitution] =
    useState(null);

  const {
    control,
    handleSubmit: submitMobileForm,
    reset: resetMobileForm,
  } = useAccountForm("mobile");

  const { mutate, isPending } = useCreateMerchantInstitutionMobileMoneyAccount();

  const openModal = useCallback((merchant) => {
    setSelectedMerchantInstitution(merchant);
  }, []);

  const closeModal = useCallback(() => {
    setSelectedMerchantInstitution(null);
    resetMobileForm();
  }, [resetMobileForm]);

  const onSubmit = createAccountSubmitHandler(
    mutate,
    (accountData) => {
      if (!selectedMerchantInstitution) {
        throw new Error("No merchant selected");
      }
      return {
        merchantId: selectedMerchantInstitution.merchantId,
        accountData,
      };
    },
    () => {
      closeModal();
      resetMobileForm();
    },
    "mobile",
  );

  const handleSubmit = submitMobileForm(onSubmit);

  const isOpen = !!selectedMerchantInstitution;

  const disableSubmit = isPending;

  return {
    isOpen,
    selectedMerchantInstitution,
    openModal,
    closeModal,
    handleSubmit,
    control,
    isCreating: isPending,
    disableSubmit,
  };
};

export default useMobileMoneyModal;
